import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { ChangeDetectionStrategy, Component, ElementRef, Input, TemplateRef, TrackByFunction, ViewChild, ViewEncapsulation } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzTableInnerScrollComponent } from "ng-zorro-antd/table";

@Component({
  selector: "ui-table-inner-scroll",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "table-inner-scroll.component.html",
})
export class UiTableInnerScrollComponent<T> extends NzTableInnerScrollComponent<T> {
  @Input("data") public data: readonly T[] = [];
  @Input("scrollX") public scrollX: string | null = null;
  @Input("scrollY") public scrollY: string | null = null;
  @Input("contentTemplate") public contentTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("widthConfig") public widthConfig: string[] = [];
  @Input("listOfColWidth") public listOfColWidth: ReadonlyArray<string | null> = [];
  @Input("theadTemplate") public theadTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("virtualTemplate") public virtualTemplate: TemplateRef<NzSafeAny> | null = null;
  @Input("virtualItemSize") public virtualItemSize = 0;
  @Input("virtualMaxBufferPx") public virtualMaxBufferPx = 200;
  @Input("virtualMinBufferPx") public virtualMinBufferPx = 100;
  @Input("tableMainElement") public tableMainElement?: HTMLDivElement;
  @Input("virtualForTrackBy") public virtualForTrackBy: TrackByFunction<T> = (index) => index;
  @Input("verticalScrollBarWidth") public verticalScrollBarWidth = 0;

  @ViewChild("tableHeaderElement", { read: ElementRef }) public tableHeaderElement!: ElementRef;
  @ViewChild("tableBodyElement", { read: ElementRef }) public tableBodyElement!: ElementRef;
  @ViewChild(CdkVirtualScrollViewport, { read: CdkVirtualScrollViewport })
  public cdkVirtualScrollViewport?: CdkVirtualScrollViewport;
}
